export default __webpack_public_path__ + "static/media/ks-aps-logo.7cba6e82.png";